<template>
  <div class="group/node border-b border-border/50 last:border-0">
    <div class="flex items-center justify-between p-3 hover:bg-muted/30 transition-all duration-200">
      <div class="flex items-center gap-3">
        <button 
          v-if="node.children && node.children.length > 0" 
          class="w-5 h-5 flex items-center justify-center text-muted-foreground hover:text-foreground transition-transform duration-200"
          :class="{ 'rotate-90': isOpen }"
          @click="isOpen = !isOpen"
        >
          <ChevronRight class="w-3.5 h-3.5" />
        </button>
        <div v-else class="w-5 h-5 flex items-center justify-center">
          <div class="w-1 h-1 bg-muted-foreground/30 rounded-full"></div>
        </div>
        
        <span class="text-sm font-bold text-foreground antialiased tracking-tight">{{ node.name }}</span>
      </div>
        <div class="flex items-center gap-1">
          <Button v-if="showMerge" variant="ghost" size="icon" class="h-8 w-8 text-indigo-500 hover:text-indigo-400 hover:bg-indigo-500/10 rounded-lg" @click="$emit('merge', node)" title="Fusionner">
            <GitMerge class="w-3.5 h-3.5" />
          </Button>
          <Button variant="ghost" size="icon" class="h-8 w-8 text-emerald-500 hover:text-emerald-400 hover:bg-emerald-500/10 rounded-lg" @click="$emit('add', node.id)" title="Sous-catégorie">
            <Plus class="w-3.5 h-3.5" />
          </Button>
          <Button variant="ghost" size="icon" class="h-8 w-8 text-amber-500 hover:text-amber-400 hover:bg-amber-500/10 rounded-lg" @click="$emit('edit', node)" title="Modifier">
            <Edit2 class="w-3.5 h-3.5" />
          </Button>
          <Button variant="ghost" size="icon" class="h-8 w-8 text-red-500 hover:text-red-400 hover:bg-red-500/10 rounded-lg" @click="$emit('delete', node.id)" title="Supprimer">
            <Trash2 class="w-3.5 h-3.5" />
          </Button>
        </div>
      </div>
    
    <div v-if="isOpen && node.children && node.children.length > 0" 
         class="ml-5 border-l-2 border-border/50 animate-in slide-in-from-left-2 duration-200">
      <CategoryNode 
        v-for="child in node.children" 
        :key="child.id" 
        :node="child"
        :depth="depth + 1"
        :show-merge="showMerge"
        @add="$emit('add', $event)"
        @edit="$emit('edit', $event)"
        @delete="$emit('delete', $event)"
        @merge="$emit('merge', $event)"
      />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { ChevronRight, Plus, Edit2, Trash2, GitMerge } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'

const props = defineProps({
  node: Object,
  depth: { type: Number, default: 0 },
  showMerge: { type: Boolean, default: false }
})

const emit = defineEmits(['add', 'edit', 'delete', 'merge'])
const isOpen = ref(true)
</script>

<style scoped>
/* Scoped styles removed in favor of Tailwind */
</style>
